export const DOWNLOAD_ALL_DOCUMENT = "DOWNLOAD_ALL_DOCUMENT";
export const DOWNLOAD_ALL_DOCUMENT_SUCCESS = "DOWNLOAD_ALL_DOCUMENT_SUCCESS";
export const DOWNLOAD_ALL_DOCUMENT_FAIL = "DOWNLOAD_ALL_DOCUMENT_FAIL";

export const GET_BIND_AUCTION_DATE = "GET_BIND_AUCTION_DATE";
export const GET_BIND_AUCTION_DATE_SUCCESS = "GET_BIND_AUCTION_DATE_SUCCESS";
export const GET_BIND_AUCTION_DATE_FAIL = "GET_BIND_AUCTION_DATE_FAIL";

//Lot no
export const GET_GETLOTNOFORTAO = "GET_GETLOTNOFORTAO";
export const GET_GETLOTNOFORTEABOARD = "GET_GETLOTNOFORTEABOARD";
export const GET_GETLOTNOBYUSERID = "GET_GETLOTNOBYUSERID";
export const GET_GETLOTNOBYUSERID_SUCCESS = "GET_GETLOTNOBYUSERID_SUCCESS";
export const GET_GETLOTNOBYUSERID_FAIL = "GET_GETLOTNOBYUSERID_FAIL";

export const GETINVOICENOFORTAO = "GETINVOICENOFORTAO";
export const GETINVOICENOFORTAO_SUCCESS = "GETINVOICENOFORTAO_SUCCESS";
export const GETINVOICENOFORTAO_FAIL = "GETINVOICENOFORTAO_FAIL";

export const GETLOTNOFORTEABOARD = "GETLOTNOFORTEABOARD";
export const GETLOTNOFORTEABOARD_SUCCESS = "GETLOTNOFORTEABOARD_SUCCESS";
export const GETLOTNOFORTEABOARD_FAIL = "GETLOTNOFORTEABOARD_FAIL";

export const GETINVOICENOBYUSERID = "GETINVOICENOBYUSERID";
export const GETINVOICENOBYUSERID_SUCCESS = "GETINVOICENOBYUSERID_SUCCESS";
export const GETINVOICENOBYUSERID_FAIL = "GETINVOICENOBYUSERID_FAIL";

export const GETINVOICENOFORTEABOARD = "GETINVOICENOFORTEABOARD";
export const GETINVOICENOFORTEABOARD_SUCCESS =
  "GETINVOICENOFORTEABOARD_SUCCESS";
export const GETINVOICENOFORTEABOARD_FAIL = "GETINVOICENOFORTEABOARD_FAIL";

export const PREVIEWPDF = "PREVIEWPDF";
export const PREVIEWPDF_SUCCESS = "PREVIEWPDF_SUCCESS";
export const PREVIEWPDF_FAIL = "PREVIEWPDF_FAIL";

export const BINDSALENOBYSEASON = "BINDSALENOBYSEASON";
export const BINDSALENOBYSEASON_SUCCESS = "BINDSALENOBYSEASON_SUCCESS";
export const BINDSALENOBYSEASON_FAIL = "BINDSALENOBYSEASON_FAIL";

export const GET_SEARCHINVOICELIST = "GET_SEARCHINVOICELIST";
export const GET_SEARCHINVOICELIST_SUCCESS = "GET_SEARCHINVOICELIST_SUCCESS";
export const GET_SEARCHINVOICELIST_FAIL = "GET_SEARCHINVOICELIST_FAIL";

export const GETUSERSBYAUCTIONCENTER = "GETUSERSBYAUCTIONCENTER";
export const GETUSERSBYAUCTIONCENTER_SUCCESS =
  "GETUSERSBYAUCTIONCENTER_SUCCESS";
export const GETUSERSBYAUCTIONCENTER_FAIL = "GETUSERSBYAUCTIONCENTER_FAIL";

export const API_STATUS_INVOICE = "API_STATUS_INVOICE";

export const DISABLED_GST_EXCEL_BUTTON = "DISABLED_GST_EXCEL_BUTTON";

export const ENABLED_GST_EXCEL_BUTTON = "ENABLED_GST_EXCEL_BUTTON";